import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    QuestionDetails: {},
}

const LanguageQuestionSlice = createSlice({
    name: "LanguageQuestionSlice",
    initialState,

    reducers: {
        LanguageQuestionData(state, action) {
            return {
                QuestionDetails: action.payload.QuestionDetails,
            };
        }
    }
})
export const { LanguageQuestionData } = LanguageQuestionSlice.actions;
export default LanguageQuestionSlice.reducer;